import React, { Component } from "react";
import PagoAporteService from "../../../../services/pagos/PagoAporteService";
import { splitImporte, formatoSeparadorMilesValue } from "../../../generico/utils/FormatoInput";
import { trackPromise } from "react-promise-tracker";
import Popup from "react-popup";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";

//// componentes reutilizables
import DataTable from "react-data-table-component";

export default class AportePaso2 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }
  
  notifiPopup = (titulo, mensaje) =>
  Popup.register({
    title: titulo,
    content: mensaje,
    buttons: {
      right: [
        {
          text: "Aceptar",
          className: "success",
          action: function () {
            Popup.close();
          },
        },
      ],
    },
  });
 
  getInitialState = () => ({
  
  });
  resetState = () => {
    this.setState(this.getInitialState());
  };
  componentDidMount() {
    
  }

  getColumn() {
    return [
      {
        name: "concepto",
        selector: row => row.concepto,
      },
      {
        name: "valor",
        selector: row => row.valor,
      },
    ];
  }

  getDatosCuenta() {
    var pagoValor = this.props.importe + " " + this.props.moneda + ".";
    var respuesta = [
      {
        concepto: "Titular de la Cuenta:",
        valor: this.props.ctaFullData.denominacion,
      },
      { concepto: "Total a Pagar:", valor: pagoValor },
      { concepto: "Importe Débito:", valor: pagoValor },
    ];
 
    return respuesta;
  }
  confirmarOperacion = () => {
    //// bloquea boton
    this.btn.setAttribute("disabled", "disabled"); 
    trackPromise(
      PagoAporteService.pagosConfirmados(
        this.props.ctaFullData.idAhorro,
        splitImporte(this.props.importe),"AP"
      ).then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);     
        if (jData.codigoRetorno === "0") {
          this.props.returnDataPaso2(jData.numeroOperacion);
          this.nextStep.click();
        } else {
          //// Habilita boton
          this.btn.removeAttribute("disabled");
          Popup.queue(this.notifiPopup("Info", jData.mensajeRetorno));
        }
      
      })
    );
  };
  render() {
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Pago</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-md-8">
            <div className="form-group">
              <label className="input-label">Cuenta Origen (a debitar):</label>
              <br />
              {this.props.ctaFullData !== undefined && (
                <label className="input-label-bold">
                  {this.props.ctaFullData.idAhorro}-
                  {this.props.ctaFullData.descripcion} Saldo:{" "}
                  {formatoSeparadorMilesValue(this.props.ctaFullData.disponible)}{" "}
                  {this.props.ctaFullData.moneda}.
                </label>
              )}
            </div>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-md-8">
            <div className="row">
              <div className="table-responsive">
                <DataTable
                  noHeader={true}
                  columns={this.getColumn()}
                  data={this.getDatosCuenta()}
                  dense={true}
                  noDataComponent="Ingrese un número de contrato para mostrar la información"
                  responsive={true}
                  noTableHead={true}
                />
              </div>
            </div>
          </div>
        </div>

        <hr />

        <div className="row">
          <div className="col-lg-8 col-md-6 ">
              <label
                className="input-label-bold float-left"
                style={{ marginTop: 10 }}
              >
                ¿Está seguro que desea CONFIRMAR la operación?
                <br />
              </label>
          </div>
          <div className="col-lg-2 col-md-3">
              <button
                className="btn btn-cu-quintary btn-consulta"
                onClick={this.props.previousStep}
              >
              <FontAwesomeIcon icon={faArrowLeft} /> Volver
              </button> 
          </div>
          <div className="col-lg-2 col-md-3">
          <button ref={btn => { this.btn = btn; }}
                className="btn btn-cu-primary"
                onClick={() => {
                  this.confirmarOperacion();
                }}
              >
                {" "}
                Confirmar <FontAwesomeIcon icon={faArrowRight} />
              </button>
              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}
              ></button>
          </div>
        </div>
      </div>
    );
  }
}
